module.exports = __webpack_public_path__ + "img/segmentacao.c9d37a75.png";